import React from "react";

const ContactUs = () => {
  return (
    <div>
      <div className="py-[3px]">
        <div className="rounded-t-[20px] w-full bg-rose-500 text-primary-content">
          <div className="card-body py-2 items-center text-center">
            <img className="w-[30px]" src="/culogo.png" alt="" />

            <h2 className="card-title text-white">Contact Us</h2>
          </div>
        </div>
      </div>

      <div className="card-body py-2 items-center text-center">
        <div className="card-body py-2 items-center text-center">
          <p>
            "cuFeeds" is web based application. Here, you will get all important
            news updated.
          </p>
        </div>
        <p>
          If you have any complaints or suggestions feel free contact with us.
        </p>
        <p className="font-semibold">Email : cufeeds@hotmail.com (24/7)</p>

        <p>Phone : +88 09638912645 (9AM - 6PM)</p>
      </div>
    </div>
  );
};

export default ContactUs;
